/*
 * Copyright (C) 2020 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeleteDialogContent } from './+model/delete-dialog-content';

@Component({
    selector: 'ngf-delete-dialog',
    templateUrl: './delete-dialog.component.html',
    styleUrls: ['./delete-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DeleteDialogComponent {

  title: string;
  text: string;
  warningText: string;
  deleteLabel: string;
  cancelLabel: string;

  constructor(private dialogRef: MatDialogRef<DeleteDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private readonly data: DeleteDialogContent) {
    this.title = this.data.title;
    this.text = this.data.text;
    this.warningText = this.data.warningText;
    this.deleteLabel = this.data.deleteLabel;
    this.cancelLabel = this.data.cancelLabel;
  }

  handleSubmit(): void {
    this.dialogRef.close(true);
  }
}
